export default "__VITE_ASSET__BCT7X3Ew__"